import { useParams } from "react-router-dom";
import { useApp } from "../../../hooks/AppProvider";
import { useEffect, useState } from "react";
import { AddButtonCell, EditDeleteCell, InputCell, NewRowTemplate, SelectCell, Table } from "../../../components/BasicComponents";

function BehaviorGroupDetailsStudentsTable({ students, avaliableStudents, assignments, onDelete, onAdd }) {
    return (
        <Table headers={["Nom de l'élève", "Score", ""]}>
            {assignments && assignments.map(assignment => (
                <BehaviorGroupDetailsStudentsRow key={assignment.id} id={assignment.id} students={students} assignment={assignment} onDelete={onDelete} />
            ))}
            {avaliableStudents.length > 0 && <BehaviorGroupDetailsStudentsNewRow avaliableStudents={avaliableStudents} onAdd={onAdd} />}
        </Table>
    )
}

function BehaviorGroupDetailsStudentsRow({ id, students, assignment, onDelete }) {

    const student = students.find(val => val.id+"" === assignment.student_id+"");
    
    const onDelete0 = () => {
        if(window.confirm("Vous êtes sur le point de supprimer " + (student?.name ?? "Élève inconnue") + " du groupe. Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    };

    return (
        <tr>
            <td>{student?.name ?? "Élève inconnue"}</td>
            <td>{(student?.score + "/20") ?? "Élève inconnue"}</td>
            <EditDeleteCell change={false} onDelete={onDelete0} />
        </tr>
    );
}

function BehaviorGroupDetailsStudentsNewRow({ avaliableStudents, onAdd }) {

    const [newStudentId, setNewStudentId] = useState("");
    
    const onAdd0 = () => {
        onAdd(newStudentId);
        setNewStudentId("");
    };

    return (
        <NewRowTemplate>
            <SelectCell 
                options={avaliableStudents.map(val => ({id: val.id, label: val.name + " (" + val.score + "/20)"}))}
                value={newStudentId}
                placeholder="- Choisir un élève -"
                onChange={e => setNewStudentId(e.target.value)}
            />
            <td></td>
            <AddButtonCell onAdd={onAdd0} />
        </NewRowTemplate>
    );
}

function BehaviorGroupDetails() {
    const app = useApp();

    const params = useParams();

    const [groupId, setGroupId] = useState(params.groupId);
    const [group, setGroup] = useState({});

    const [students, setStudents] = useState([]);
    const [avaliableStudents, setAvaliableStudents] = useState([]);
    const [groupAssignments, setGroupAssignments] = useState([]);
    const [assignments, setAssignments] = useState([]);

    const [groupMean, setGroupMean] = useState(0);

    useEffect(() => {
        app.sendGet("/behavior/details/" + groupId, (data) => {
            if(data.success === false) {
                app.navigate("/404")
                return;
            }

            setGroup(data);
        });

        app.sendGet("/behavior/list/students", students => {
            setStudents(students);
        });

        app.sendGet("/behavior/assignments", assignments => {
            setAssignments(assignments);
        });
    }, []);

    useEffect(() => {
        const assignmentStudentIds = assignments.map(val => val.student_id+"");
        setAvaliableStudents(students.filter(val => !assignmentStudentIds.includes(val.id+"")));

        const groupAssignments0 = assignments.filter(val => val.group_id+"" === groupId+"")
        setGroupAssignments(groupAssignments0);

        if(groupAssignments0.length == 0) {
            setGroupMean(0);
        }else {
            let sum = 0;
            for(let student of students)
                if(groupAssignments0.find(val => val.student_id+"" === student.id+"") !== undefined)
                    sum += Number(student.score);

            setGroupMean((sum / groupAssignments0.length).toFixed(2));
        }
    }, [students, assignments]);


    const onDeleteStudent = (id) => {
        app.sendPost("/behavior/details/" + groupId + "/remove", {id: id}, data => {
            if(data.success === false)
                return alert("Une erreur s'est produite [1]");

            setAssignments(assignments.filter(val => val.id !== id));
        });
    }
          
    const onAddStudent = (newStudentId) => {
        if(app.emptyCheck(newStudentId))
            return alert("Veuillez choisir un éleve avant");

        app.sendPost("/behavior/details/" + groupId + "/assign", {student_id: newStudentId}, data => {
            if(data.success === false)
                return alert("Une erreur s'est produite [0]");

            setAssignments([...assignments, data]);
        });
    }

    return (
        <div>
            <h1>Détail du groupe: {group.name}</h1>
            <h2>Moyenne du groupe: {groupMean}/20</h2>
            <h2>Composition</h2>
            <BehaviorGroupDetailsStudentsTable
                avaliableStudents={avaliableStudents}
                students={students}
                assignments={groupAssignments}
                onDelete={onDeleteStudent}
                onAdd={onAddStudent}
            />
        </div>
    )
}

export default BehaviorGroupDetails;